import { Injectable } from '@angular/core';
import { IStatusBar } from '../common/inject';

@Injectable({
  providedIn: 'root'
})
export class StatusBarService {

  private _statusBarVisible: boolean = false;
  private _statusBar: IStatusBar;

  get statusBarVisible(): boolean {
    return this._statusBarVisible;
  }

  set statusBarVisible(sbv: boolean) {
    this._statusBarVisible = sbv;
  }

  get statusBar(): IStatusBar {
    return this._statusBar;
  }

  set statusBar(sb: IStatusBar) {
    this._statusBar = sb;
  }

  public refresh() {
    if (this.statusBarVisible)
      this.statusBar?.refresh();
  }
}
